var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('br'),_vm._v(" "),_c('img',{attrs:{"alt":"Control T","src":require("../assets/logo.png")}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }